import React from "react";
import { Mail, Phone, MapPin } from "lucide-react";
import "./style.css"; // We'll define normal CSS here
// import { Button } from "../../components/ui/button";
import Navigation from "../../components/Navigation";
import Footer from "../../components/Footer";
import { Helmet } from "react-helmet-async";
// import Contact_BG from "../../assets/images/contact-bg.avif";
import { FaTwitter, FaInstagram, FaFacebook, FaYoutube, FaBehance } from "react-icons/fa";

const ContactPage = () => {
  return (
    <div>
      <div className="contact-bg"><div className="contact-overlay"></div></div>

    <section id="contact" className="contact-section">
      <Navigation />
      <Helmet>
        <title>Contact Us - Big Cat Graphics</title>
        <meta name="description" content="Get in touch with Big Cat Graphics for your graphic design needs. Contact us via email, phone, or social media to discuss your project and bring your vision to life." />
      </Helmet>
      <div className="container">
        <div className="section-header">
          <h2>Get In Touch</h2>
          <p>Ready to bring your vision to life? Let's discuss your next project</p>
        </div>

        <div className="contact-grid">
          {/* Contact Info */}
          <div className="contact-info">
            <h3>Let's Talk</h3>

            <div className="contact-items">
              <div className="contact-item">
                <div className="icon-circle">
                  <Mail className="icon" />
                </div>
                <div>
                  <div className="item-title">Email</div>
                  <div className="item-text"><a href="mailto:info@bigcatgraphics.co.za">info@bigcatgraphics.co.za</a></div>
                </div>
              </div>

              <div className="contact-item">
                <div className="icon-circle">
                  <Phone className="icon" />
                </div>
                <div>
                  <div className="item-title">Phone</div>
                  <div className="item-text"><a href="tel:+27719142461">+27 71 914 2461</a></div>
                </div>
              </div>

              <div className="contact-item">
                <div className="icon-circle">
                  <MapPin className="icon" />
                </div>
                <div>
                  <div className="item-title">Location</div>
                  <div className="item-text">Johannesburg</div>
                </div>
              </div>
            </div>

            <div className="socials">
              <h4>Follow Us</h4>
              <div className="social-icons">
                <a href="https://x.com/_bigcatgraphics/" target="_blank" rel="noopener noreferrer"><FaTwitter size={20} className="social-icon" /></a>
                <a href="https://www.instagram.com/bigcatgraphics?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer"><FaInstagram size={20} className="social-icon" /></a>
                <a href="https://www.facebook.com/BigCatGraphics" target="_blank" rel="noopener noreferrer"><FaFacebook size={20} className="social-icon" /></a>
                <a href="https://www.youtube.com/@bigcatgraphics007" target="_blank" rel="noopener noreferrer"><FaYoutube size={20} className="social-icon" /></a>
                <a href="https://www.behance.net/jamesmsaikond" target="_blank" rel="noopener noreferrer"><FaBehance size={20} className="social-icon" /></a>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          {/* <div className="contact-form-wrapper">
            <form className="contact-form">
              <div className="grid-cols-2">
                <div className="form-group">
                  <label>Name</label>
                  <input type="text" placeholder="Your name" />
                </div>
                <div className="form-group">
                  <label>Email</label>
                  <input type="email" placeholder="your@email.com" />
                </div>
              </div>

              <div className="form-group">
                <label>Subject</label>
                <input type="text" placeholder="Project inquiry" style={{ width: "94%" }} />
              </div>

              <div className="form-group">
                <label>Message</label>
                <textarea placeholder="Tell us about your project..." />
              </div>

              <Button type="submit" className="btn-submit">Send Message</Button>
            </form>
          </div> */}
        </div>
      </div>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
    </section>
    
    <Footer />
    </div>
  );
};

export default ContactPage;
